// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

export const lazyLoadKeyframes = () => {
    return css`
        @keyframes lazyLoad {
            0% {
                background-position: 100% 0;
            }
            100% {
                background-position: 0 0;
            }
        }

        @keyframes lazyLoadFadeIn {
            0% {
                opacity: 0;
            }
            100% {
                opacity: 1;
            }
        }
    `;
};

export const lazyLoadStyles = () => {
    return css`
        background: ${getColor("common.accent")};
        background: linear-gradient(
            -90deg,
            ${getColor("common.accent")} 25%,
            ${getColor("common.background")} 50%,
            ${getColor("common.accent")} 75%
        );
        background-size: 400% 400%;
        animation:
            lazyLoad 2s ease infinite,
            lazyLoadFadeIn 250ms ease;
    `;
};
